import React from 'react';

const HelpModal = ({ 
  isOpen, 
  onClose, 
  title = "Why Create an Account?",
  message = "Create an account to automatically match your mood to games you own or can play online. Track play sessions, wins and losses, share recaps of your play with your group, and much more!"
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="safe-area-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-primary, white)',
          borderRadius: '8px',
          padding: '2rem',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '80dvh',
          overflow: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: '0 0 1rem 0', color: 'var(--text-primary, #333)' }}>
          {title}
        </h3>
        <p style={{ 
          margin: '0 0 1.5rem 0', 
          lineHeight: '1.5',
          color: 'var(--text-secondary, #666)'
        }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: 'var(--pista-button-bg, #2E7D32)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '600',
            width: '100%'
          }}
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default HelpModal;
